// extracted by mini-css-extract-plugin
module.exports = {"propertyView":"PropertyView_propertyView__1ujy4","item":"PropertyView_item__1957C","name":"PropertyView_name__kg-jA","value":"PropertyView_value__8icHW"};